export const BASE_URL = process.env.REACT_APP_BASE_URL
export const BASE_API = process.env.REACT_APP_API_URL
export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
export const GOOGLE_LOCATION_KEY = process.env.REACT_GOOGLE_LOCATION_KEY
export const BASE_STORAGE_URL = process.env.REACT_APP_STORAGE_URL
export const EVENT_LOGIN_MODAL = 'EVENT_LOGIN_MODAL'
export const EVENT_SIGNUP_MODAL = 'EVENT_SIGNUP_MODAL'

export const PRODUCT_ID = 1
export const CATEGORY_ID = 2

export const ATTRIBUTE_TYPES = {
  TEXT: 'TEXT',
  CHECKBOX: 'CHECKBOX',
  CHECKBOX_GROUP: 'CHECKBOX_GROUP',
  RADIO_GROUP: 'RADIO_GROUP',
  SELECT: 'SELECT',
}

export const OFFERS_STATUS = {
  new: { name: 'NEW_REQUEST' },
}
